<div class="loader-container">
  <h2 class="color-primary">{{ data.message || 'Loading...' }}</h2>
  <mat-progress-bar mode="query"></mat-progress-bar>
</div>
